import script from "./LoggedLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoggedLayout.vue?vue&type=script&lang=ts&setup=true"

import "./LoggedLayout.vue?vue&type=style&index=0&id=3baeed99&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3baeed99"]])

export default __exports__